import { experimentalStyled } from '@material-ui/core/styles';

const LogoRoot = experimentalStyled('svg')``;

const Logo = (props) => (
  <img src="https://www.cumuluscreativeconcierge.com/images/logo_80.png" />
);

export default Logo;
